import React, { CSSProperties, ElementType, FC, RefObject, useCallback, useMemo } from 'react';
import cn from 'classnames';
import { Icon } from '../Icon';
import { ITypographyVariants, ITypographyWeights, Typography } from '../Typography';
import { PaginationContext, IPaginationContextValue } from './PaginationContext';
import { PaginationItem } from './Item';
require("./Pagination.css");
var styles = {
  "Root": "Pagination-module-Root_2gW",
  "Dots": "Pagination-module-Dots_KAs",
  "ArrowBtn": "Pagination-module-ArrowBtn_q09",
  "NumbersContainer": "Pagination-module-NumbersContainer_3Hd"
};
export const Pagination = ({
  activePageNumber = 1,
  className,
  controlRef,
  innerRef,
  onChangePageNumber = () => {},
  style = {},
  tag = 'div',
  totalPagesCount = 1,
  typographyVariant = 'p4',
  typographyWeight = 'default',
  arrowSize = 'm',
  fontSize = '12px'
}) => {
  const Component = tag;
  const validActivePageNumber = useMemo(() => {
    const isValid = activePageNumber > 0 && activePageNumber <= totalPagesCount;
    if (!isValid && process.env.NODE_ENV === 'development') {
      console.warn('Передано некорректное значение активной страницы. Автоматически назначено 1');
    }
    return isValid ? activePageNumber : 1;
  }, [activePageNumber, totalPagesCount]);
  const handleChangePageNumber = useCallback(pageNumber => {
    if (pageNumber > 0 && pageNumber <= totalPagesCount) onChangePageNumber(pageNumber);
  }, [onChangePageNumber, totalPagesCount]);
  const handleClickBack = useCallback(() => {
    handleChangePageNumber(validActivePageNumber - 1);
  }, [handleChangePageNumber, validActivePageNumber]);
  const handleClickForward = useCallback(() => {
    handleChangePageNumber(validActivePageNumber + 1);
  }, [handleChangePageNumber, validActivePageNumber]);
  const providerValue = useMemo(() => {
    return {
      onClick: handleChangePageNumber,
      activePageNumber: validActivePageNumber,
      typographyVariant,
      typographyWeight,
      fontSize
    };
  }, [handleChangePageNumber, validActivePageNumber, typographyVariant, typographyWeight, fontSize]);
  return /*#__PURE__*/React.createElement(Component, {
    className: cn(styles.Root, className),
    style: {
      ...style,
      fontSize
    },
    ref: innerRef || controlRef
  }, /*#__PURE__*/React.createElement(PaginationContext.Provider, {
    value: providerValue
  }, validActivePageNumber !== 1 && /*#__PURE__*/React.createElement("button", {
    "aria-label": "\u041D\u0430\u0437\u0430\u0434",
    className: styles.ArrowBtn,
    onClick: handleClickBack
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "arrowForward",
    size: arrowSize,
    style: {
      transform: 'rotate(180deg)'
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.NumbersContainer
  }, /*#__PURE__*/React.createElement(PaginationItem, {
    pageNumber: 1
  }), validActivePageNumber >= 5 && /*#__PURE__*/React.createElement(Typography, {
    className: styles.Dots,
    variant: typographyVariant,
    weight: typographyWeight,
    style: {
      fontSize
    }
  }, "..."), validActivePageNumber >= 4 && /*#__PURE__*/React.createElement(PaginationItem, {
    pageNumber: validActivePageNumber - 2
  }), validActivePageNumber >= 3 && /*#__PURE__*/React.createElement(PaginationItem, {
    pageNumber: validActivePageNumber - 1
  }), validActivePageNumber !== 1 && validActivePageNumber !== totalPagesCount && /*#__PURE__*/React.createElement(PaginationItem, {
    pageNumber: validActivePageNumber
  }), activePageNumber < totalPagesCount - 1 && /*#__PURE__*/React.createElement(PaginationItem, {
    pageNumber: validActivePageNumber + 1
  }), validActivePageNumber < totalPagesCount - 2 && /*#__PURE__*/React.createElement(PaginationItem, {
    pageNumber: validActivePageNumber + 2
  }), validActivePageNumber < totalPagesCount - 3 && /*#__PURE__*/React.createElement(Typography, {
    className: styles.Dots,
    variant: typographyVariant,
    weight: typographyWeight,
    style: {
      fontSize
    }
  }, "..."), totalPagesCount !== 1 && /*#__PURE__*/React.createElement(PaginationItem, {
    pageNumber: totalPagesCount
  })), validActivePageNumber !== totalPagesCount && /*#__PURE__*/React.createElement("button", {
    "aria-label": "\u0412\u043F\u0435\u0440\u0435\u0434",
    className: styles.ArrowBtn,
    onClick: handleClickForward
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "arrowForward",
    size: arrowSize
  }))));
};
if (process.env.NODE_ENV !== 'production') {
  Pagination.displayName = 'Pagination';
}